import { baseApiService } from './base'
import type { PaginatedParams, PaginatedResponse } from './common'

export interface Environment extends Record<string, unknown> {
  id: string
  name: string
}

export type EnvironmentsResponse = PaginatedResponse<Environment>
export type EnvironmentsParams = PaginatedParams

export async function getEnvironments(params: EnvironmentsParams): Promise<EnvironmentsResponse> {
  return baseApiService.fetch<EnvironmentsResponse>('/api/etmf/masterdata/ENVIRONMENT', {
    params
  })
}
